module.exports = __webpack_public_path__ + "static/media/nurul-aqilah.d4d38fa9.jpg";